export enum Actions {
  OPEN_MENU = '@PROFILESETTINGS/OPEN_MENU',
  CLOSE_MENU = '@PROFILESETTINGS/CLOSE_MENU'
}
